import axiosClient from "../api/axiosClient";

/**
 * Access Requests service — incoming event-host access requests (the
 * receiving side of Phase 4's host-request feature: other event owners
 * asking this promoter to be a host/helper on their events).
 * Ported 1:1 from the React Native app's pending-event-access screen
 * (src/Screens/pending-event-access) and the API functions it calls in
 * src/services/api/index.js + src/services/constants/index.js. No new
 * backend endpoints — both already live.
 */

export const getMyAccessRequests = () => axiosClient.get("/EventAssistant/GetMyAccessContactRequests");

/** @param {string|number} requestId @param {boolean} accept */
export const respondToAccessRequest = (requestId, accept) =>
  axiosClient.post("/EventAssistant/RespondAccessContactRequest", JSON.stringify({ requestId, accept }));
